import { render, staticRenderFns } from "./PopupFileUploadLicenses.vue?vue&type=template&id=2975fa38&scoped=true&"
import script from "./PopupFileUploadLicenses.vue?vue&type=script&lang=js&"
export * from "./PopupFileUploadLicenses.vue?vue&type=script&lang=js&"
import style0 from "./PopupFileUploadLicenses.vue?vue&type=style&index=0&id=2975fa38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2975fa38",
  null
  
)

export default component.exports